import { SITE_URL, SITE_NAME, MEDIA_URL } from '../config/seoConfig';

/**
 * Generate BlogPosting schema for blog posts
 * @param {Object} article - Article data
 * @param {string} article.title - Article title
 * @param {string} article.excerpt - Article excerpt/summary
 * @param {string} article.image - Article hero image URL
 * @param {string} article.publishedDate - Publication date (ISO format)
 * @param {string} article.modifiedDate - Last modified date (ISO format)
 * @param {string} article.author - Author name
 * @param {string} article.slug - Article URL slug
 * @param {Array<string>} article.tags - Article tags
 * @param {string} lang - Language code
 */
export const generateArticleSchema = (article, lang = 'en') => ({
  '@context': 'https://schema.org',
  '@type': 'BlogPosting',
  headline: article.title,
  description: article.excerpt,
  image: article.image,
  datePublished: article.publishedDate,
  dateModified: article.modifiedDate || article.publishedDate,
  author: {
    '@type': 'Person',
    name: article.author || 'SunCatchers Team',
  },
  publisher: {
    '@type': 'Organization',
    name: SITE_NAME,
    logo: {
      '@type': 'ImageObject',
      url: `${MEDIA_URL}/images/logo/suncatchers-logo.png`,
    },
  },
  mainEntityOfPage: {
    '@type': 'WebPage',
    '@id': `${SITE_URL}/${lang}/blog/${article.slug}`,
  },
  keywords: article.tags ? article.tags.join(', ') : undefined,
});
